import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ReactPlayer from 'react-player';
import Text from '../BioCard/Text'
let text = `The members of the 9/11 Commission reunite to reflect on the largest investigation in US history and to assess our nation’s progress over the last 20 years.  The film will air in the fall of 2022.`

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'column wrap',
        alignItems: 'center',
        width: '100vw',
        height: 'auto',
        padding: '1vw'

    },
    header: {
        width: '100%',
        height: 'auto',
        fontSize: '34px',
        paddingTop: '6vw',
        padding: '2vw',
        textAlign:'center',
    },
    textContainer: {
        width: '60vw',
        margin: 'auto',
        fontSize: '22px',
        paddingBottom: '3vh'
    },
   
    vidWrapper: {
        width: '60vw'
    },
    [theme.breakpoints.down('sm')]: {
    vidWrapper: {
        width: '90vw'
    },
    }}
    
  
))

export default function VideoCard() {
    const classes = useStyles()
    return (
        <div id={'documentary'} className={classes.container}> 
            <div className={classes.header}>Documentary Film Trailer</div>
            <Text theme={classes.textContainer}>{text}</Text>
             <div className={classes.vidWrapper}>
                <ReactPlayer width="100%"  url="https://youtu.be/1bbhl_rRld8"/>
             </div>
        </div>
    )
}
